import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgTwitch from './assets/Twitch.png';
import ImgT1 from './assets/T1.jpg';

import ImgEsportsOne from '../assets/EsportsOne.png';
import ImgClimateDashboard from '../assets/ClimateDashboard.png';

export default class Twitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='Twitch'
            year='2019 — Present'
            position='Senior Product Designer'
          />
          <div className={css.content}>
            <img src={ImgTwitch} alt='Twitch' />
            <div className={css.text}>
              <p>Twitch is the world’s leading live stream platform. Millions of people come together everyday to watch, chat, and make their own interactive entertainment live on Twitch. </p>
              <p>Twitch has a strong lead in the PC and console gaming markets, but has significant room to grow in mobile gaming. I work as a senior product designer with a focus on emerging markets and mobile gamers. My team’s ambitious goal is to jump start Twitch’s mobile games content and position Twitch as the premier destination for mobile games content. </p>
              <p>My team was responsible for the launch of the mobile broadcasting feature on the iOS and Android platforms allowing anyone with a phone to stream directly to Twitch. Released in select regions in early 2020, we now have several hundred thousand new mobile creators using our feature each month. In the nearly two years I’ve been at Twitch we’ve been the fastest growing segment and produced nearly 1000% growth year over year. </p>
            </div>
            <img src={ImgT1} alt='Mobile Broadcasting' />
            <div className={css.text}>
              <p>Alongside lowering the barrier for mobile broadcasters to start streaming and making a living on Twitch, my team also experiments with mobile-first features that increase mobile viewership, participation, and monetization. In a recent experiment we ran, we increased performance of Clips views by over 300%. </p>
              <p>Working for a globally recognised brand in an area with massive growth potential with a free license to experiment is a truly special opportunity. </p>
            </div>
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Esports One Design System'
                  description='Figma design system for an esports startup'
                  position='Freelance Product Designer'
                  img={ImgEsportsOne}
                  link='EsportsOne'
                />
                <ProjectItem
                  title='Climate Impact Dashboard'
                  description='B2B pivot for an Amsterdam-based green startup'
                  position='Freelance Product Manager & Designer'
                  img={ImgClimateDashboard}
                  link='ClimateDashboard'
                />
              </ul>
          </div>
        </div>
      )
   }
}
